var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessenger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "currentColor",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99797 1.00133C4.21469 0.927527 1.08747 3.92626 1 7.70954C1.01093 9.63398 1.86108 11.4573 3.33175 12.7011V14.7075C3.33175 14.8688 3.46296 15 3.62424 15C3.67891 15 3.73358 14.9836 3.78005 14.9563L5.40653 13.9421C6.23481 14.2592 7.11502 14.4205 8.0007 14.4177C11.784 14.4916 14.9112 11.4928 14.9987 7.71227C14.9085 3.92626 11.7812 0.927527 7.99797 1.00133Z",
    stroke: "inherit",
    fill: "none",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6037 5.78527C12.5162 5.66772 12.3577 5.63492 12.2292 5.70326L9.19767 7.35708L7.31149 5.7388C7.19668 5.64039 7.02447 5.64585 6.91512 5.7552L3.41614 9.25418C3.30133 9.36899 3.30406 9.55215 3.41614 9.66696C3.50635 9.75716 3.64849 9.77903 3.76057 9.71616L6.79211 8.06234L8.68102 9.68062C8.79583 9.77903 8.96805 9.77357 9.07739 9.66422L12.5764 6.16524C12.6802 6.06136 12.6912 5.90008 12.6037 5.78527Z",
    fill: "inherit",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessenger);
export default __webpack_public_path__ + "static/media/messenger.7a433a62.svg";
export { ForwardRef as ReactComponent };